import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

import { CustomerFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';

import { Observable } from 'rxjs';

@Component({
    templateUrl: './account-detail-page.component.html',
    styleUrls: ['./account-detail-page.component.scss']
})
export class AccountDetailPageComponent extends BaseComponent implements OnInit, OnDestroy {
    accountDeletionSuccess = false;
    accountDeletionEmailSuccess$: Observable<boolean> = this.customerFacade.isDeletionEmailSuccess$;
    constructor(
        @Inject('ENV') public env: Env,
        private customerFacade: CustomerFacade
    ) {
        super();
    }

    ngOnInit() {
        this.customerFacade.setAvailableProfileActions(this.env.ACCOUNT.PROFILE_ACTIONS);

        this.customerFacade.setCustomerFields(this.getAccountDetailFields(this.env.ACCOUNT.FORMFIELDS));

        this.customerFacade.sendCustomerProfileDeletionEmailSuccess(false);
    }

    getAccountDetailFields(envDetails) {
        const detailFields = [];

        envDetails.forEach((formField) => {
            detailFields.push(formField.toLowerCase());
        });

        return detailFields;
    }
}
